export class ActionCableServiceClass {
    constructor() {
        this.channel = 'OperationChannel';
    }
    
    init({vue=null}){
        this.vue = vue;
    }
    unsubscribe(){
        this.vue.$cable.subscribe(this.channel);
    }
    subscribe({meetId=null}){
        this.vue.$cable.subscribe({
            channel: this.channel,
            meet_id: meetId
        });
    }
    chooseTopic({topicId=null}){
        var _data = {
            topic_id: topicId
        }
        this.perform({action: 'choose_topic', data: _data})
    }
    startTopic(){
        var _data = { }
        this.perform({action: 'start_topic', data: _data})
    }
    pauseTopic(){
        var _data = { }
        this.perform({action: 'pause_topic', data: _data})
    }
    finishTopic(){
        this.perform({action: 'finish_topic'})
    }
    changeTopicDuration({duration=null}){
        var _data = {
            new_duration: duration
        }
        this.perform({action: 'change_topic_duration', data: _data})
    }
    changeTopicPosition({topicId=null, position=null}){
        var _data = {
            topic_id: topicId,
            new_position: position
        }
        this.perform({action: 'change_topic_position', data: _data})
    }
    finishMeet(){
        this.perform({action: 'finish_meet'})
    }
    createComment({comment=null, topicId=null}){
        var _data = {
            comment: comment, 
            topic_id: topicId
        }
        this.perform({action: 'create_comment', data: _data});
    }
    perform({channel=this.channel, action=null, data={}}){
        this.vue.$cable.perform({
            channel: channel,
            action: action,
            data: data
        });
    }
}

export const ActionCableService = new ActionCableServiceClass();